





































import { Vue, Prop, Component } from 'vue-property-decorator';

import TextInput from '@/components/TextInput/TextInput.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

@Component({
  components: {
    TextInput,
    FormLabel,
    Typography
  }
})
export default class TextInputMaxCharacter extends Vue {
  @Prop() label!: string;
  @Prop() value!: string;
  @Prop() placeholder!: string;
  @Prop() maxLength!: number;
  @Prop({ default: false }) textarea?: boolean;
  @Prop({ default: '' }) errorMessage?: string;
}
